import { render, staticRenderFns } from "./VxSidebarItem.vue?vue&type=template&id=7783cbce&"
import script from "./VxSidebarItem.vue?vue&type=script&lang=js&"
export * from "./VxSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7783cbce')) {
      api.createRecord('7783cbce', component.options)
    } else {
      api.reload('7783cbce', component.options)
    }
    module.hot.accept("./VxSidebarItem.vue?vue&type=template&id=7783cbce&", function () {
      api.rerender('7783cbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vx-sidebar/VxSidebarItem.vue"
export default component.exports